import React, { useState, useEffect } from "react";
import Select from "react-select";
import { getRequest } from "../../../../../utils/httpRequest";
import Filter from "bad-words";
import { t } from "../../../../../utils/i18n";

const OtherSettings = ({ updateParent, getData, handleProfanityDetection, handleForbiddenOfferNameDetection, handleForbiddenOfferLabelDetection }) => {
  const [predefinedTags, setPredefinedTags] = useState([]);
  const [profanityError, setProfanityError] = useState({});
  const [offerNameError, setOfferNameError] = useState("");
  const [offerLabelError, setOfferLabelError] = useState("");

  const getTags = () => {
    getRequest("/p2p_trades/tags").then((response) => {
      const tags = response.map((tag) => ({
        label: tag.name,
        value: tag.slug,
      }));

      setPredefinedTags(tags);
    });
  };

  useEffect(() => {
    getTags();
  }, []);

  const filter = new Filter();

  const handleInputChange = (field, value) => {
    if (field === "offerTerms" || field === "customOfferLabel") {
      if (filter.isProfane(value)) {
        setProfanityError((prevErrors) => ({
          ...prevErrors,
          [field]: true,
        }));
        handleProfanityDetection(true);
        return;
      }
    }

    setProfanityError((prevErrors) => ({
      ...prevErrors,
      [field]: false,
    }));

    const anyProfanityDetected = Object.values(profanityError).some(
      (error) => error
    );
    handleProfanityDetection(anyProfanityDetected);

    updateParent(field, value);
  };

  const validateOfferName = (event) => {
    const forbiddenPattern = /(?:banana[\W_]*crystal|crystal[\W_]*banana|banana|bcrystal|bacrystal|bancrystal|banacrystal|banancrystal|bananacryst|banananacrysta|bananacry[\W_]*stal)/i;  
    const name = event.target.value;
  
    if (forbiddenPattern.test(name)) {
      // Show an error or prevent the change
      setOfferNameError(t("p2p.settings.name_forbidden"));
      handleForbiddenOfferNameDetection(true);
      return false;
    }
  
    setOfferNameError("");
    handleForbiddenOfferNameDetection(false);
    return true;
  };
  
  const validateOfferLabel = (event) => {
    const forbiddenPattern = /(?:banana[\W_]*crystal|crystal[\W_]*banana|banana|bcrystal|bacrystal|bancrystal|banacrystal|banancrystal|bananacryst|banananacrysta|bananacry[\W_]*stal)/i;  
    const name = event.target.value;
  
    if (forbiddenPattern.test(name)) {
      // Show an error or prevent the change
      setOfferLabelError(t("p2p.settings.name_forbidden"));
      handleForbiddenOfferLabelDetection(true);
      return false;
    }
  
    setOfferLabelError("");
    handleForbiddenOfferLabelDetection(false);
    return true;
  };

  return (
    <div className="createoffer-othersettings">
      <div className="mb-3">
        <h4 className="createoffer-paymentmethod-labels">{t("p2p.settings.title")}</h4>
      </div>
      <div className="offerinstructions-form">
        <div>
          <div>
            <form className="col-md-12 px-0">
              <div className="form-group ">
                <div style={{ width: "100%" }}>
                  <strong>
                    <label htmlFor="exampleInputEmail1" className="createoffer-sublabels">
                      {t("p2p.settings.tags")} <span style={{ color: "red" }}>*</span>
                    </label>
                  </strong>
                  <Select
                    options={predefinedTags}
                    isMulti={true}
                    placeholder={t("p2p.settings.tags_placeholder")}
                    value={getData("tags") || null}
                    onChange={(items) => {
                      updateParent("tags", items);
                    }}
                  />
                  <p id="emailHelp" className="form-text text-muted">
                    {t("p2p.settings.tags_help")}
                  </p>
                </div>
              </div>
              <div className=" form-group">
                <strong>
                  <label htmlFor="exampleInputPassword1" className="createoffer-sublabels">
                    {t("p2p.settings.name")} <span style={{ color: "red" }}>*</span>
                  </label>
                </strong>
                <input
                  type="text"
                  className={`form-control ${
                    profanityError.customOfferLabel ? "is-invalid" : ""
                  }`}
                  id="exampleInputPassword1"
                  placeholder={t("p2p.settings.name_placeholder")}
                  maxLength={25}
                  defaultValue={getData("customOfferLabel") || ""}
                  onChange={(event) => {
                    if (validateOfferName(event)) {
                      handleInputChange("customOfferLabel", event.target.value); // Only call handleChange if validation succeeds
                    }
                  }}
                />
                {offerNameError &&  <div className="createoffer-error-alert">
                    {offerNameError}
                  </div>}
                {profanityError.customOfferLabel && (
                  <div className="createoffer-error-alert">
                    {t("p2p.settings.label_profanity")}
                  </div>
                )}
                <p id="emailHelp" className="form-text text-muted">
                  {t("p2p.settings.name_help")}
                </p>
              </div>
              <div className=" form-group">
                <strong>
                  <label htmlFor="exampleInputPassword1" className="createoffer-sublabels">
                    {t("p2p.settings.terms")} <span style={{ color: "red" }}>*</span>
                  </label>
                </strong>
                <textarea
                  className={`form-control ${
                    profanityError.offerTerms ? "is-invalid" : ""
                  } createoffer-input`}
                  id="exampleInputPassword1"
                  placeholder={t("p2p.common.terms_placeholder")}
                  defaultValue={getData("offerTerms") || ""}
                  onChange={(event) => {
                    if (validateOfferLabel(event)) {
                      handleInputChange("offerTerms", event.target.value); // Only call handleChange if validation succeeds
                    }
                  }}
                ></textarea>
                                {offerLabelError &&  <div className="createoffer-error-alert">
                    {offerLabelError}
                  </div>}
                {profanityError.offerTerms && (
                  <div className="invalid-feedback createoffer-error-alert">
                    {t("p2p.settings.terms_profanity")}
                  </div>
                )}
                <p id="emailHelp" className="form-text text-muted">
                  {t("p2p.common.terms_help")}
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtherSettings;
